import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(['getAllGameResetIndex', 'getResetExgame', 'getmember'])
  },
  watch: {
    getAllGameResetIndex: 'getAllGameList',
    getResetExgame: 'getpmtgeList'
  },
  methods: {
    ...mapActions(['setAllGame', 'setExgame']),
    async getAllGameList () {
      try {
        let res = await this.$axios.gameLobby.gamelist()
        if ('status' in res && res.status === 0) return
        this.setAllGame(res)
      } catch (error) {
        console.error(error)
      }
    },
    async getpmtgeList () {
      try {
        const gamefirmList = await this.$axios.cq9.getElectronicGameMaker()
        const res = await this.$axios.cq9.getpmtge()
        const exgameList = res.map(it => {
          it['gamehall'] = it.gamename.split('-')[0]
          it.id = it.gametypeid
          const gamefirm = gamefirmList.filter(item => item.idop == 1).find(item => item.gamehall.toLowerCase() == it.gamehall.toLowerCase())
          it.catenaId = gamefirm ? gamefirm.hallsid : null
          return it
        }).filter(it => it.catenaId)
        this.setExgame(exgameList)
      } catch (error) {
        console.log(error);
      }
    },
  },
}